import React from "react";
import { useTranslation } from 'react-i18next';
import moment from 'moment';

// MUI
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import { useTheme, useMediaQuery } from '@mui/material';

// MUI Icons
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

// Custom
import PublicRouteMap from '@/views/GIS/MapPage/PublicRouteMap';
import MapRoutingProvider from '@/components/MapRoutingContext/MapRoutingProvider';
import MapRouteProfile from '@/components/MapRouting/MapRouteProfile';
import MapRouteInfo from '@/components/MapRouting/MapRouteInfo';

// Types
import { DCRecord } from '@/@types/lib/dataController';


type IPublicIzletDaySectionProps = {
  danRbr: number;
  datum: string;
  opis: string;
  routePoints: DCRecord[];
  expandedDefault?: boolean;
  noDivider?: boolean;
};


const PublicIzletDaySection = (props: IPublicIzletDaySectionProps) => {
  const { danRbr, datum, opis, routePoints, expandedDefault, noDivider } = props;
  const { t } = useTranslation();

  const theme = useTheme();
  const isMobile: boolean = !useMediaQuery(theme.breakpoints.up('lg'));

  return (
    <Grid size={12}>
      <Accordion defaultExpanded={expandedDefault} elevation={0} sx={{ bgcolor: 'transparent' }}>
        <AccordionSummary
          sx={{ padding: { xs: '8px 0px' } }}
          expandIcon={<ExpandMoreIcon color="primary" sx={{ transform: { lg: 'scale(2.0)', xs: 'scale(1.4)' } }} fontSize="large" />}
        >
          <Typography color='primary' variant='h4' component="h1" fontSize={isMobile ? '1.7rem' : undefined}>
            {`${danRbr}. ${t('common.day.day')}  / ${moment(datum).format('dddd, D.M.YYYY.')}`}
          </Typography>
        </AccordionSummary>
        <AccordionDetails sx={{ paddingX: 0 }}>
          <Grid container spacing={3}>
            <Grid size={{ xs: 12, lg: 6 }}>
              <Typography variant="body1" fontSize={isMobile ? '1.1rem' : '1.2rem'}>
                {opis}
              </Typography>
            </Grid>
            <Grid size={{ xs: 12, lg: 6 }}>
              <MapRoutingProvider>
                <MapRouteInfo />
                <MapRouteProfile />
                {routePoints ? (
                  <Box sx={{ aspectRatio: '1/1', width: '100%' }}>
                    <PublicRouteMap mapId={11} initialRecordRoutePoints={routePoints as DCRecord[]} />
                  </Box>
                ) : null}
              </MapRoutingProvider>
            </Grid>
          </Grid>
        </AccordionDetails>
      </Accordion>
      {!noDivider && <Divider sx={{ borderColor: 'primary.main' }} />}
    </Grid>
  );
};

export default PublicIzletDaySection;
